import { Modal, Result, Button } from 'antd';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { handleModifyCatalogue } from '../../../services/utils/catalogueModificationUtils';

const ConfirmCloseModal = ({
    modalState,
    setModalState,
    isDraftSavable,
    currentDraftId,
    draftFormData,
    formInstance, // Form instance for unified system
    originalCatalogueId, // Original catalogue ID for published modifications
    fetchCatalogues,
    isEditMode,
    messageApi,
    statusTokens
}) => {
    return (
        <Modal
            open={modalState === 'closeConfirm'}
            onCancel={() => setModalState('closed')}
            centered
            footer={null}
        >
            <Result
                icon={<WarningAmberIcon style={{ color: statusTokens.warning, fontSize: 64 }} />}
                title={isEditMode && currentDraftId ?
                    "Do you want to save the changes to this draft before closing?" :
                    "Do you want to save this catalogue as a draft before closing?"
                }
                extra={[
                    <Button key="save" type="primary" disabled={!isDraftSavable} onClick={async () => {
                        try {
                            // Check if this is a modification of a published catalog or a regular draft
                            if (originalCatalogueId && !currentDraftId) {
                                // This is a NEW draft from a published catalog - use the unified system
                                const currentFormData = formInstance ? formInstance.getFieldsValue(true) : draftFormData;
                                await handleModifyCatalogue({
                                    formData: currentFormData,
                                    form: formInstance,
                                    originalCatalogueId: originalCatalogueId,
                                    existingDraftId: currentDraftId,
                                    messageApi,
                                    onSuccess: () => {
                                        setModalState('closed');
                                        fetchCatalogues(true);
                                    }
                                });
                            } else if (currentDraftId) {
                                // This is an existing draft - use the working drafted system
                                const { updateDraftedCatalogue } = await import('../../../services/api/catalogueDraftService');
                                await updateDraftedCatalogue(currentDraftId, draftFormData);
                                messageApi.success('Draft catalogue updated successfully.');
                                setModalState('closed');
                                fetchCatalogues(true);
                            } else {
                                // This is a new draft - use the working drafted system
                                const { saveDraftedCatalogue } = await import('../../../services/api/catalogueDraftService');
                                await saveDraftedCatalogue(draftFormData);
                                messageApi.success('Catalogue saved as draft.');
                                setModalState('closed');
                                fetchCatalogues(true);
                            }
                        } catch (err) {
                            console.error('Error saving/updating draft:', err);
                            messageApi.error('Error saving draft: ' + (err.message || err));
                        }
                    }}>
                        {isEditMode && currentDraftId ? 'Save Changes' : 'Save as Draft'}
                    </Button>,
                    <Button key="discard" onClick={() => {
                        setModalState('closed');
                        messageApi.info('Changes discarded.');
                    }}>
                        Discard Changes
                    </Button>,
                    <Button key="cancel" type="link" onClick={() => setModalState('main')}>
                        Cancel
                    </Button>
                ]}
            />
        </Modal>
    )
}

export default ConfirmCloseModal;